/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/CodeCoverageSummaryView" />
import { ICodeCoverageSummaryViewProps } from 'Actions/CodeCoverageTabActionHub';
import * as Resources from 'CodeCoverage/CodeCoverageTab/Resources';
import * as React from 'react';
import {
    DataType,
    DifferenceType,
    ResultSummaryNumberChartComponent,
    ValueType,
} from 'Test/TestSummary/Components/ResultSummaryDetailsChart';
import { VssComponent } from 'VSS/Platform/Layout';


const DefaultNumberChartProps = {
    dataType: DataType.String,
    difference: {
        value: "",
        valueType: ValueType.Unchanged,
        shouldShowIcon: false,
        diffType: DifferenceType.Unchanged,
    }
};

export interface IBuildCodeCoverageSummaryViewState {
    moduleCount: number;
    totalLines: number;
    totalCoveredLines: number;
    coveragePercent: string;
}

export class CodeCoverageSummaryView extends VssComponent<ICodeCoverageSummaryViewProps, IBuildCodeCoverageSummaryViewState> {
    constructor(props: ICodeCoverageSummaryViewProps) {
        super(props);
        this.state = {
            moduleCount: this.props.moduleCount,
            totalLines: this.props.totalLines,
            totalCoveredLines: this.props.totalCoveredLines,
            coveragePercent: this.props.coveragePercent
        } as IBuildCodeCoverageSummaryViewState;
    }
    
    public componentDidUpdate(prevProps: ICodeCoverageSummaryViewProps, prevState: IBuildCodeCoverageSummaryViewState) {
        super.componentDidUpdate(prevProps, prevState);
        if (this.props !== prevProps) {
            this.setState({
                moduleCount: this.props.moduleCount,
                totalLines: this.props.totalLines,
                totalCoveredLines: this.props.totalCoveredLines,
                coveragePercent: this.props.coveragePercent
            } as ICodeCoverageSummaryViewProps);
            
        }
    }
    public render(): JSX.Element {

        if (this.props.moduleCount == 0) {
            return (
                <div className="code-coverage-summary-container">
                    <ResultSummaryNumberChartComponent
                        title={Resources.LineCoverageText}
                        value={this.props.coveragePercent}
                        {...DefaultNumberChartProps}
                    />

                    <ResultSummaryNumberChartComponent
                        title={Resources.TotalCoverageLinesText}
                        value={this.props.totalLines}
                        {...DefaultNumberChartProps}
                    />
                    <ResultSummaryNumberChartComponent
                        title={Resources.CoveredLinesText}
                        value={this.props.totalCoveredLines}
                        {...DefaultNumberChartProps}
                    />
                </div>
            );
        }
        return (
            <div className="code-coverage-summary-container">
                <ResultSummaryNumberChartComponent
                    title={Resources.LineCoverageText}
                    value={this.props.coveragePercent}
                    {...DefaultNumberChartProps}
                />
 
                <ResultSummaryNumberChartComponent
                    title={Resources.ModuleCoverageText}
                    value={this.props.moduleCount}
                    {...DefaultNumberChartProps}
                />
                <ResultSummaryNumberChartComponent
                    title={Resources.TotalCoverageLinesText}
                    value={this.props.totalLines}
                    {...DefaultNumberChartProps}
                />
                <ResultSummaryNumberChartComponent
                    title={Resources.CoveredLinesText}
                    value={this.props.totalCoveredLines}
                    {...DefaultNumberChartProps}
                />
            </div>
        );
    } 
}
